import { MeshUtils } from "@dreamcam/babylon-tools";
export class SubmenuHandlers {
    constructor(mesh) {
        this._timeout = undefined;
        this.showSubmenu = (duration) => {
            this.hideSubmenuCancel();
            if (duration !== undefined)
                this._timeout = setTimeout(this.hideSubmenuInstantly, duration);
            MeshUtils.setVisibility(this._mesh, true);
        };
        this.hideSubmenuStart = (delay) => {
            this.hideSubmenuCancel();
            if (delay === undefined)
                this.hideSubmenuInstantly();
            else
                this._timeout = setTimeout(this.hideSubmenuInstantly, SubmenuHandlers.shortLifetime);
        };
        this.hideSubmenuCancel = () => {
            if (this._timeout !== undefined)
                clearTimeout(this._timeout);
            this._timeout = undefined;
        };
        this.hideSubmenuInstantly = () => {
            this.hideSubmenuCancel();
            MeshUtils.setVisibility(this._mesh, false);
        };
        this._mesh = mesh;
    }
}
SubmenuHandlers.longLifetime = 1200;
SubmenuHandlers.shortLifetime = 1200;
